var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Children, isValidElement, cloneElement, forwardRef } from 'react';
import { Avatar, AvatarLetter, TeamAvatar, UserAvatar } from 'modules/v2/dataDisplay/Avatar';
import { AvatarWithLabel } from '../AvatarWithLabel';
import { AvatarGroupContainer } from './styled';
function isValidAvatarComponent(child) {
    return (child.type === AvatarWithLabel || child.type === UserAvatar || child.type === TeamAvatar || child.type === Avatar);
}
export const AvatarGroup = forwardRef((props, ref) => {
    const { limit = 3, children, size = 'md' } = props, rest = __rest(props, ["limit", "children", "size"]);
    const childrenCount = Children.count(children);
    const plusCount = childrenCount - limit;
    const plusLetter = `+${plusCount.toString()}`;
    const slicedChildren = Children.toArray(children)
        .slice(0, limit)
        .map((child) => {
        if (isValidElement(child) && isValidAvatarComponent(child)) {
            return cloneElement(child, Object.assign(Object.assign({}, child.props), { size, withLabel: childrenCount === 1 }));
        }
        return null;
    });
    return (<AvatarGroupContainer $size={size} ref={ref} {...rest}>
      {slicedChildren}
      {plusCount > 0 && (<Avatar size={size} appearance="secondary">
          <AvatarLetter>{plusLetter}</AvatarLetter>
        </Avatar>)}
    </AvatarGroupContainer>);
});
